export default "__VITE_PUBLIC_ASSET__fffe4636__"